(() => {
  // A supplied link label is a clue, never verified attribution or consent.
  const tags = {
    utm_source: 'facebook',
    utm_medium: 'organic_social',
    utm_campaign: 'jrg_manufacturing_nov2026',
    utm_content: 'printed_components',
  };
  const paths = new Set([
    'custom-3d-printing-manufacturing', 'automotive-3d-printing',
    'marine-boat-components', 'engineering-industrial-prototyping',
    'custom-replacement-parts', '3d-scanning-reverse-engineering',
    'large-format-manufacturing', 'manufacturing-portfolio', 'manufacturing-quote',
  ].map(handle => '/pages/' + handle));
  if (!paths.has(location.pathname) || location.search.length > 4096) return;
  const supplied = new URLSearchParams(location.search);
  if (!Object.entries(tags).every(([key, value]) => supplied.getAll(key).length === 1 && supplied.get(key) === value)) return;

  function attach(scope = document) {
    const sections = scope.matches?.('.jrg-mfg') ? [scope] : scope.querySelectorAll('.jrg-mfg');
    sections.forEach(section => {
      if (section.dataset.jrgCampaignBound) return;
      section.dataset.jrgCampaignBound = 'true';
      section.querySelectorAll('a[href]').forEach(link => {
        try {
          const target = new URL(link.getAttribute('href'), location.href);
          if (target.origin !== location.origin || target.username || target.password || !paths.has(target.pathname) || target.search) return;
          // Transfer only these fixed public tags. Never copy the incoming query,
          // referrer, click IDs, unrelated parameters or cross-origin links.
          for (const [key, value] of Object.entries(tags)) target.searchParams.set(key, value);
          link.setAttribute('href', target.pathname + target.search + target.hash);
        } catch { /* Preserve malformed or unsupported links unchanged. */ }
      });
      const source = section.querySelector('input[data-jrg-campaign-source]');
      if (source && !source.disabled && !source.readOnly && !source.value.trim()) {
        source.value = 'Facebook manufacturing post';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => attach(), { once: true });
  else attach();
  document.addEventListener('shopify:section:load', event => attach(event.target));
})();
